module.exports = __webpack_public_path__ + "static/media/hp_10.29dc686f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_10.jpg
// module id = 5821
// module chunks = 0